<template>
  <Btn
    :color="color"
    href="https://shop.atlasti.com/74/purl-order?tracking=gtm"
    target="_blank"
    data-test-id="license-upgrade-button"
  >
    {{ $t('licensing.action.upgrade') }}
  </Btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LicenseUpgradeAction',

  props: {
    color: {
      type: String,
      default: 'blue',
    },
  },
});
</script>
